module.exports = __webpack_public_path__ + "b68089cd4989792528384a76f5869118.svg";